'use strict';

const SoaCollection = require('bunsen/collections/SoaCollection');

const Recommendation = require('bunsen/models/identity/Recommendation');
const endpoints = require('dibs-endpoints');

const Recommendations = SoaCollection.extend({
    url: endpoints.recommendations(),
    model : Recommendation,

    TYPE_CATEGORY: 'CATEGORY',
    TYPE_ATTRIBUTE: 'ATTRIBUTE'
});

module.exports = Recommendations;



// WEBPACK FOOTER //
// ./~/bunsen/collections/identity/Recommendations.es.js